import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ElementRef, effect } from '@angular/core';
import { FormBuilder, FormGroup, AbstractControl, ValidationErrors } from '@angular/forms';
import { HttpParams } from '@angular/common/http';
import { Subject, forkJoin } from 'rxjs';
import { debounceTime, pairwise, startWith, takeUntil } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { DialogSeguimientoCotizacionComponent } from '../common/dialogs/dialog-seguimiento-cotizacion/dialog-seguimiento-cotizacion.component';
import { ConsultarLineasGruposProgramasService } from '../../services/cotizador-programas/consultar-lineas-grupos-programas.service';
import { CotizacionEstadoService } from '../../services/cotizacion-estado/cotizacion-estado.service';
import { SeguimientoJefeService } from '../../services/seguimiento-jefe/seguimiento-jefe.service';
import { AuthService } from '../../services/security/auth.service';
import { RegistroSeguimiento } from '../../models/seguimiento-jefe/asesor-jefe.model';
import { AsesorService } from '../../models/codigo-asesor/asesor.service';
import { AsesorStore } from '../../models/codigo-asesor/codigo-asesor.store';
import { NgxSpinnerService } from 'ngx-spinner';
import { MaincontainerComponent } from '../maincontainer/maincontainer.component';
import { ConsultarAsesorByIDService } from '../../services/cotizador-contratante/consultar-asesor-by-id.service';
import { SnackBarService } from '../../utils/util.SnackBarService';
import { NetworkingMyQuotation } from '../../services/mis-cotizaciones/miscotizaciones.service';
import { AsesorData } from '../../models/cotizador-contratante/consultar-asesor/response/consultar-asesor-byID-response.model';
import { environment } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

interface Asesor {
  codigo: string;
  nombre: string;
}

interface EstadoCotizacion {
  value: string;
  label: string;
}

interface TipoSolicitud {
  value: string;
  label: string;
}

interface Cotizacion {
  asesorCodigo: string;
  asesorNombre: string;
  numeroCotizacion: string;
  idTipoSolicitud: number;
  fechaCreacion: Date;
  tipoSolicitud: string;
  lineasNegocio: string[];
  estado: string;
  fechaCierre?: Date | null;
  seguimiento: 'vencidas' | 'por_gestionar' | 'cumplimiento';
  fechaSeguimiento?: Date | null;
  pdfUrl?: string;
  nombreContratante?: string;
}

interface ExportarCotizacion {
  idCotizacion: number;
  numero_cotizacion: string;
  fecha: string;
  nombre_contratante: string;
  no_documento: string;
  tipo_solicitud: string;
  linea_negocio: string;
  estado: string;
  probabilidad_cierre: string;
  seguimiento: string;
  colorSemaforo: string; // "red" | "yellow" | "green" | "gray" | "none"
  idTipoCotizacion: number; // 1 = Individual, 2 = Colectivo Estándar
}


interface ChartPoint {
  label: string;
  value: number;
}

interface BarChartItem {
  label: string;
  value: number;
  altura: string;
}

interface SvgBar {
  rx: number;
  ry: number;
  rw: number;
  rh: number;
  label: string;
  value: number;
  labelX: number;
  labelY: number;
  valueX: number;
  valueY: number;
}

interface CotizacionParametroTrazabilidad {
  idParametro: number;
  tipoParametro: string;
  valorParametro: string;
}


@Component({
  selector: 'app-cotizador-seguimiento',
  templateUrl: './cotizador-seguimiento.component.html',
  styleUrls: ['./cotizador-seguimiento.component.css']
})
export class CotizadorSeguimientoComponent implements OnInit, AfterViewInit, OnDestroy {
  
  filtrosForm: FormGroup;
  minDate: Date;
  maxDate: Date;

  estadosCotizacion: EstadoCotizacion[] = [];

  tipoSolicitud: TipoSolicitud[] = [];

  asesores: Asesor[] = [];
  filteredAsesores: Asesor[] = [];
  asesorBusqueda = '';

  private _onDestroy = new Subject<void>();

  logInfo: any;
  cedula_Asesor: any;
  IdAsesor: any;
  private datosSeguimientoCargados = false;
  nombreAsesor: string = '';
  correoAsesor: string = '';
  celularAsesor: string = '';
  ciudadAsesor: string = '';
  parametrosTipoAccion: CotizacionParametroTrazabilidad[] = [];
  parametrosNombreAccion: CotizacionParametroTrazabilidad[] = [];
  parametrosTrazabilidadCargados = false;

  constructor(
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private lineasService: ConsultarLineasGruposProgramasService,
    private estadoService: CotizacionEstadoService,
    private seguimientoJefeService: SeguimientoJefeService,
    private authService: AuthService,
    private asesorService: AsesorService,
    private asesorStore: AsesorStore,
    private spinner: NgxSpinnerService,
    private mainCmp: MaincontainerComponent,
    private consultarAsesorByIDService: ConsultarAsesorByIDService,
    private networking: NetworkingMyQuotation,
  ) {
    // Configurar rango de fechas
    this.maxDate = new Date();
    this.minDate = new Date();
    this.minDate.setFullYear(this.minDate.getFullYear() - 100);

    // Inicializar dataSource
    this.dataSource = new MatTableDataSource<Cotizacion>([]);

    // Inicializar formulario
    this.filtrosForm = this.fb.group({
      fechaCotizacionDesde: [null],
      fechaCotizacionHasta: [null],
      estadoCotizacion: [''],
      tipoSolicitud: [[]],
      fechaCierreDesde: [null],
      fechaCierreHasta: [null],
      asesorComercial: ['']
    }, {
      validators: [
        this.validarRangoFechasCotizacion(),
        this.validarRangoFechasCierre()
      ]
    });

    effect(() => {
      const asesor = this.asesorStore.asesor();
      this.IdAsesor = asesor?.idasesor ?? null;

      if (this.IdAsesor) {
        console.log('Id Asesor obtenido:', this.IdAsesor);

        if (!this.datosSeguimientoCargados) {
          this.datosSeguimientoCargados = true;
          this.cargarAsesores();
          this.cargarRegistros();
        }
      }
    });
  }
  private readonly KEY_PARAMETROS_JASPER_STORAGE = 
  'parametros_jasper_individual';
  private readonly KEY_PARAMETROS_JASPER_COLECTIVO_STORAGE =
  'parametros_jasper_colectivo';
  activeTab: 'dashboard' | 'registros' = 'dashboard';
  busquedaGeneral = '';
  totalCotizaciones = 0;
  porcentajeCumplimientoMeta = 0;
  tiempoPromedioCierre = 0;
  metaCotizaciones = 120;

  lineChartData: ChartPoint[] = [];
  lineChartPolylinePoints = '';
  lineChartNodes: Array<{ cx: number; cy: number; label: string; value: number; showLabel: boolean; labelX: number; labelY: number; labelTransform: string }> = [];
  lineChartGridLines: Array<{ y: number; value: number }> = [];
  readonly lineChartViewBox = '0 0 620 280';

  pieChartData: Array<{ label: string; value: number; color: string }> = [];
  pieChartBackground = 'conic-gradient(#e0e0e0 0 100%)';
  pieSvgSlices: Array<{ path: string; color: string; labelX: number; labelY: number; pct: string }> = [];

  seguimientoChartData: BarChartItem[] = [];
  lineasNegocioChartData: BarChartItem[] = [];
  seguimientoSvgBars: SvgBar[] = [];
  seguimientoSvgGridLines: Array<{ y: number; value: number }> = [];
  lineasNegocioSvgBars: SvgBar[] = [];
  lineasNegocioSvgGridLines: Array<{ y: number; value: number }> = [];
  readonly barChartViewBox = '0 0 380 240';
  tieneSeguimientoDatos = false;
  tieneLineasDatos = false;

  todasCotizaciones: Cotizacion[] = [];

  filteredCotizaciones: Cotizacion[] = [];
  dataSource: MatTableDataSource<Cotizacion>;
  displayedColumns: string[] = [
    'asesorComercial',
    'numeroCotizacion',
    'fechaCreacion',
    'tipoSolicitud',
    'lineasNegocio',
    'estado',
    'fechaCierre',
    'seguimiento',
    'acciones'
  ];
  pageSizeOptions: number[] = [10, 25, 50, 100];
  pageSize = 10;
  
  private _paginator!: MatPaginator;
  @ViewChild('asesorSearchInput')
  asesorSearchInput?: ElementRef<HTMLInputElement>;

  @ViewChild('asesorSelectContainer')
  asesorSelectContainer?: ElementRef<HTMLElement>;

  @ViewChild(MatPaginator)
  set matPaginator(paginator: MatPaginator) {
    if (paginator) {
      this._paginator = paginator;
      this.dataSource.paginator = paginator;
    }
  }

  get paginator(): MatPaginator {
    return this._paginator;
  }

  readonly seguimientoLabels: Record<string, string> = {
    vencidas: 'Vencidas',
    por_gestionar: 'Por gestionar',
    cumplimiento: 'Cumplimiento'
  };

  private obtenerIdParametroTrazabilidad(
    lista: CotizacionParametroTrazabilidad[],
    valorParametro: string
  ): number | null {
    const parametro = lista.find(item =>
      String(item.valorParametro ?? '').trim().toUpperCase() ===
      String(valorParametro ?? '').trim().toUpperCase()
    );

    return parametro?.idParametro ?? null;
  }

  private cargarParametrosTrazabilidad(): void {
    forkJoin({
      tiposAccion: this.networking.consultarParametrosTrazabilidad('TIPO_ACCION'),
      nombresAccion: this.networking.consultarParametrosTrazabilidad('NOMBRE_ACCION')
    })
    .pipe(takeUntil(this._onDestroy))
    .subscribe({
      next: ({ tiposAccion, nombresAccion }) => {
        this.parametrosTipoAccion = tiposAccion ?? [];
        this.parametrosNombreAccion = nombresAccion ?? [];
        this.parametrosTrazabilidadCargados = true;

        console.log('✅ Parámetros tipo acción:', this.parametrosTipoAccion);
        console.log('✅ Parámetros nombre acción:', this.parametrosNombreAccion);
      },
      error: (error) => {
        this.parametrosTrazabilidadCargados = false;
        console.error('❌ Error cargando parámetros de trazabilidad:', error);
      }
    });
  }

  private registrarTrazabilidad(
    tipoAccion: 'BOTON' | 'FILTRO' | 'BUSCADOR',
    nombreAccion: string,
    valorAccion: any,
    idCotizacion?: number | string | null
  ): void {

    console.log('ENTRÓ A registrarTrazabilidad()', {
      tipoAccion,
      nombreAccion,
      valorAccion,
      idCotizacion
    });

    if (!this.parametrosTrazabilidadCargados) {
      console.warn('⚠️ No se registra trazabilidad porque los parámetros aún no han cargado.');
      return;
    }

    const idTipoAccion = this.obtenerIdParametroTrazabilidad(
      this.parametrosTipoAccion,
      tipoAccion
    );

    const idNombreAccion = this.obtenerIdParametroTrazabilidad(
      this.parametrosNombreAccion,
      nombreAccion
    );

    if (!idTipoAccion || !idNombreAccion) {
      console.error('❌ No se encontró parametrización para la trazabilidad', {
        tipoAccion,
        nombreAccion,
        idTipoAccion,
        idNombreAccion,
        parametrosTipoAccion: this.parametrosTipoAccion,
        parametrosNombreAccion: this.parametrosNombreAccion
      });
      return;
    }

    const idCotizacionNumerico =
      idCotizacion !== null && idCotizacion !== undefined && idCotizacion !== ''
        ? Number(idCotizacion)
        : null;

    const request = {
      idCotizacion: idCotizacionNumerico,
      cedulaAsesor: String(this.cedula_Asesor ?? '').trim(),
      nombreAsesor: String(this.nombreAsesor ?? '').trim(),
      idTipoAccion,
      idNombreAccion,
      valorAccion: this.formatearValorTracking(valorAccion)
    };

    console.log('REQUEST TRAZABILIDAD:', request);

    this.networking.registrarTrazabilidad(request).subscribe({
      next: (response) => {
        console.log('✅ Trazabilidad registrada:', response);
      },
      error: (error) => {
        console.error('❌ Error registrando trazabilidad:', error);
      }
    });
  }

  private formatearValorTracking(valor: any): string {
    if (valor === null || valor === undefined || valor === '') {
      return 'SIN VALOR';
    }

    if (valor instanceof Date) {
      return this.formatearFechaBusqueda(valor);
    }

    if (Array.isArray(valor)) {
      return valor.length ? valor.join(', ') : 'SIN VALOR';
    }

    if (typeof valor === 'object') {
      return JSON.stringify(valor);
    }

    return String(valor);
  }

  async ngOnInit(): Promise<void> {
    this.logInfo = await this.authService.getAuthInfo();
    console.log('servicio auth documento', this.logInfo);

    const userCC = this.logInfo?.document;
    this.cedula_Asesor = userCC.split('.')[1].trim();

    console.log('Seguimiento cotizaciones: cedulaAsesor ->', this.cedula_Asesor);

    await this.obtenerCCAsesor();
    this.cargarDatosAsesor();

    this.cargarParametrosTrazabilidad();

    this.asesorService.getAsesorPorDocumento(this.cedula_Asesor);

    this.cargarTiposSolicitud();
    this.cargarEstadosCotizacion();

    this.filtrosForm.valueChanges
      .pipe(
        startWith(this.filtrosForm.value),
        pairwise(),
        debounceTime(300),
        takeUntil(this._onDestroy)
      )
      .subscribe(([valorAnterior, valorActual]) => {
        this.aplicarFiltros();

        const filtro = this.obtenerFiltroModificado(valorAnterior, valorActual);

        if (filtro) {
          this.registrarTrazabilidad(
            'FILTRO',
            filtro.nombre,
            filtro.valor,
            null
          );
        }
      });

    this.aplicarFiltros();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.mainCmp.setTitle('SEGUIMIENTO A COTIZACIONES');
    });

    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
    }
  }

  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  async obtenerCCAsesor(): Promise<string> {
    try {
      const authInfo = await this.authService.getAuthInfo();
      const documentUser = authInfo.document;
      console.log('Información de autenticación obtenida:', authInfo);

      // Extraer la cédula del documento
      this.cedula_Asesor = documentUser.split('.')[1].trim();
      console.log('📝 Documento asesor:', this.cedula_Asesor);

      // Obtener el idAsesor usando el servicio
      this.IdAsesor = await this.networking.obtenerIdAsesorPorDocumento(this.cedula_Asesor);
      console.log('✅ ID Asesor obtenido:', this.IdAsesor);

      return this.cedula_Asesor;

    } catch (error) {
      console.error('❌ Error al obtener la información de autenticación:', error);
      return this.cedula_Asesor;
    }
  }

  private cargarDatosAsesor(): void {
    if (!this.IdAsesor) {
      return;
    }

    const request = {
      nombreClave: 'getSpCotConsultarAsesorPorID',
      jsonParametros: JSON.stringify({
        prm_id_asesor: String(this.IdAsesor)
      })
    };

    this.consultarAsesorByIDService.consultarAsesorByID(request).subscribe({
      next: (response) => {
        if (response?.status && Array.isArray(response.data) && response.data.length > 0) {
          const asesor = response.data[0];
          this.nombreAsesor = (asesor?.NombreCompleto ?? '').toString().trim();
          this.correoAsesor = (asesor?.email ?? '').toString().trim();
          this.celularAsesor = (asesor?.telefono ?? '').toString().trim();
          this.ciudadAsesor = this.capitalizeFirstLetter(
            (asesor?.ciudad ?? '').toString().trim()
          );
        }
      },
      error: (error) => {
        console.error('Error al consultar los datos del asesor:', error);
      }
    });
  }

  private obtenerFiltroModificado(valorAnterior: any, valorActual: any): { nombre: string; valor: any } | null {
    const nombresFiltros: Record<string, string> = {
      fechaCotizacionDesde: 'Fecha cotización desde',
      fechaCotizacionHasta: 'Fecha cotización hasta',
      estadoCotizacion: 'Estado de la cotización',
      tipoSolicitud: 'Tipo de solicitud',
      fechaCierreDesde: 'Fecha cierre desde',
      fechaCierreHasta: 'Fecha cierre hasta',
      asesorComercial: 'Asesor comercial'
    };

    for (const campo of Object.keys(nombresFiltros)) {
      const anterior = this.formatearValorTracking(valorAnterior?.[campo]);
      const actual = this.formatearValorTracking(valorActual?.[campo]);

      if (anterior !== actual) {
        return {
          nombre: nombresFiltros[campo],
          valor: valorActual?.[campo]
        };
      }
    }

    return null;
  }

  private capitalizeFirstLetter(value: string): string {
    const trimmed = (value ?? '').toString().trim();
    if (!trimmed) {
      return '';
    }
    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
  }

  onAsesorSelectAbierto(abierto: boolean): void {
    if (!abierto) {
      return;
    }

    this.asesorSelectContainer?.nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
      this.asesorSearchInput?.nativeElement.focus();
    }, 300);
  }

  /**
   * Validador personalizado para verificar que la fecha desde no sea posterior a la fecha hasta
   * en el rango de fechas de cotización
   */
  validarRangoFechasCotizacion() {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const fechaDesde = formGroup.get('fechaCotizacionDesde')?.value;
      const fechaHasta = formGroup.get('fechaCotizacionHasta')?.value;

      if (fechaDesde && fechaHasta && fechaDesde > fechaHasta) {
        return { fechaCotizacionInvalida: true };
      }
      return null;
    };
  }

  /**
   * Validador personalizado para verificar que la fecha desde no sea posterior a la fecha hasta
   * en el rango de fechas de cierre
   */
  validarRangoFechasCierre() {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const fechaDesde = formGroup.get('fechaCierreDesde')?.value;
      const fechaHasta = formGroup.get('fechaCierreHasta')?.value;

      if (fechaDesde && fechaHasta && fechaDesde > fechaHasta) {
        return { fechaCierreInvalida: true };
      }
      return null;
    };
  }

  /**
   * Carga los estados de cotización desde el servicio
   */
  private cargarEstadosCotizacion(): void {
    this.estadoService.getEstadosCotizacion().subscribe({
      next: (res) => {
        if (res?.data) {
          this.estadosCotizacion = res.data.map(e => ({
            value: e.nombre?.toLowerCase().trim(),
            label: this.formatearTexto(e.nombre)
          }));
        }
      },
      error: (err) => {
        console.error('Error cargando estados de cotización', err);
      }
    });
  }

  private formatearTexto(valor: string): string {
    return valor
      ? valor.toLowerCase().replace(/\b\w/g, letra => letra.toUpperCase())
      : '';
  }

  /**
   * Carga las líneas de negocio desde el servicio de parámetros
   */
  private cargarTiposSolicitud(): void {
    // Cargar opciones específicas de tipos de solicitud
    this.tipoSolicitud = [
      // Nuevo colectivo queda oculto en el filtro. No se borra.
      // {
      //   value: 'colectivo_nuevo',
      //   label: 'NUEVO COLECTIVO'
      // },
      {
        value: 'inclusion',
        label: 'INCLUSIÓN'
      },
      {
        value: 'venta_nueva',
        label: 'VENTA NUEVA'
      }
    ];
  }

  /**
   * Carga los asesores comerciales del jefe logueado
   */
  private cargarAsesores(): void {
    const idJefe = String(this.IdAsesor ?? '').trim();
    if (!idJefe) {
      return;
    }

    this.seguimientoJefeService.getAsesoresPorJefe(idJefe)
      .pipe(takeUntil(this._onDestroy))
      .subscribe({
        next: (res) => {
          const datos = Array.isArray(res?.data) ? res.data : [];

          this.asesores = datos
            .filter((asesor) =>
              asesor?.idasesor !== null &&
              asesor?.idasesor !== undefined &&
              asesor?.nombre_asesor
            )
            .map((asesor) => ({
              codigo: String(asesor.idasesor).trim(),
              nombre: String(asesor.nombre_asesor).trim()
            }))
            .sort((a, b) =>
              Number(a.codigo) - Number(b.codigo)
            );

          this.filteredAsesores = [...this.asesores];
        },
        error: (err) => {
          console.error('Error cargando asesores', err);
          this.asesores = [];
          this.filteredAsesores = [];
        }
      });
  }

  private cargarRegistros(): void {
    const idJefe = String(this.IdAsesor ?? '').trim();

    if (!idJefe) {
      return;
    }

    this.spinner.show();

    this.seguimientoJefeService.getRegistrosSeguimiento(idJefe)
      .pipe(takeUntil(this._onDestroy))
      .subscribe({
        next: (res) => {
          if (res?.data?.contenido) {
            this.todasCotizaciones = res.data.contenido.map(item => this.mapearRegistro(item));
          } else {
            this.todasCotizaciones = [];
          }

          this.aplicarFiltros();
          this.spinner.hide();
        },
        error: (err) => {
          console.error('Error cargando registros de seguimiento', err);

          this.todasCotizaciones = [];
          this.aplicarFiltros();

          this.spinner.hide();

          this.snackBar.open(
            'No se pudo completar la operación. Por favor intente nuevamente. Si el problema persiste, contacte al administrador del sistema.',
            'Cerrar',
            { duration: 4000 }
          );
        }
      });
  }

  /** SO y SAO representan la misma línea de negocio; se unifican bajo SAO. */
  private normalizarLineaNegocio(linea: string): string {
    const normalizada = linea.trim().toUpperCase();
    return normalizada === 'SO' ? 'SAO' : normalizada;
  }

  /** Salida temporal: en seguimiento solo se visualiza Medicina Integral. */
  private filtrarLineasNegocioVisibles(lineas: string[]): string[] {
    return lineas.filter((linea) => linea === 'MI');
  }

  private mapearRegistro(item: RegistroSeguimiento): Cotizacion {
    const lineas = item.lineaNegocio
      ? this.filtrarLineasNegocioVisibles(
          [...new Set(
            item.lineaNegocio
              .split(/[,\-]/)
              .map(l => this.normalizarLineaNegocio(l))
              .filter(l => !!l)
          )]
        )
      : [];
    let fechaProx: Date | null = null;
    if (item.fechaProxContacto) {
      const stringFecha = String(item.fechaProxContacto);
      const partesFecha = stringFecha.split('-');
      if (partesFecha.length >= 3) {
        const anio = parseInt(partesFecha[0], 10);
        const mes = parseInt(partesFecha[1], 10) - 1;
        const dia = parseInt(partesFecha[2].split('T')[0], 10);
        fechaProx = new Date(anio, mes, dia);
      } else {
        fechaProx = new Date(item.fechaProxContacto);
      }
    }
    return {
      asesorCodigo: String(item.idAsesor ?? '').trim(),
      asesorNombre: String(item.nombreAsesor || (item as any).nombre_asesor || this.asesores.find(a => a.codigo === String(item.idAsesor))?.nombre || '').trim(),
      numeroCotizacion: String(item.idCotizacion),
      idTipoSolicitud: item.idTipoSolicitud,
      fechaCreacion: new Date(item.fechaCreacion),
      tipoSolicitud: item.nombreTipoSolicitud,
      lineasNegocio: lineas,
      estado: item.nombreEstado ? item.nombreEstado.toLowerCase().trim() : 'incompleta',
      fechaCierre: item.fechaCierre ? new Date(item.fechaCierre) : null,
      seguimiento: this.calcularSeguimiento(fechaProx),
      fechaSeguimiento: fechaProx,
      nombreContratante: item.nombreContratante
    };
  }

  private calcularSeguimiento(fechaProx: Date | null): 'vencidas' | 'por_gestionar' | 'cumplimiento' {
    if (!fechaProx) return 'por_gestionar';
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    const f = new Date(fechaProx);
    f.setHours(0, 0, 0, 0);
    if (f < hoy) return 'vencidas';
    // Amarillo si faltan uno o dos días (el día del vencimiento también). Desde el tercero, verde.
    const limite = new Date(hoy);
    limite.setDate(limite.getDate() + 2);
    if (f <= limite) return 'por_gestionar';
    return 'cumplimiento';
  }

  /**
   * Aplica los filtros seleccionados para actualizar el dashboard y la tabla
   */
  aplicarFiltros(): void {
    if (this.filtrosForm.invalid) {
      return;
    }

    this.filteredCotizaciones = this.obtenerCotizacionesFiltradas();
    this.dataSource.data = this.filteredCotizaciones;

    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
      this.paginator.firstPage();
    }

    this.actualizarDashboard();
  }

  /**
   * Limpia todos los filtros y restablece el formulario a su estado inicial
   */

  private normalizarTexto(valor: any): string {
    return String(valor ?? '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  private formatearFechaBusqueda(fecha: any): string {
    if (!fecha) {
      return '';
    }

    const fechaObj = new Date(fecha);

    if (isNaN(fechaObj.getTime())) {
      return '';
    }

    const dia = String(fechaObj.getDate()).padStart(2, '0');
    const mes = String(fechaObj.getMonth() + 1).padStart(2, '0');
    const anio = fechaObj.getFullYear();

    return `${dia}/${mes}/${anio}`;
  }

  limpiarFiltros(): void {
    this.filtrosForm.reset({
      fechaCotizacionDesde: null,
      fechaCotizacionHasta: null,
      estadoCotizacion: '',
      tipoSolicitud: [],
      fechaCierreDesde: null,
      fechaCierreHasta: null,
      asesorComercial: ''
    });

    this.asesorBusqueda = '';
    this.filteredAsesores = [...this.asesores];
    this.busquedaGeneral = '';

    this.registrarTrazabilidad(
      'BOTON',
      'Limpiar filtros',
      'Click',
      null
    );

    this.aplicarFiltros();
  }

  cambiarTab(tab: 'dashboard' | 'registros'): void {
    this.activeTab = tab;

    this.registrarTrazabilidad(
      'BOTON',
      'Cambiar tab',
      tab === 'dashboard' ? 'Dashboard' : 'Registros',
      null
    );
  }

  aplicarBusquedaGeneral(): void {
    this.aplicarFiltros();

    this.registrarTrazabilidad(
      'BUSCADOR',
      'Buscador general',
      this.busquedaGeneral,
      null
    );
  }

  limpiarBusquedaGeneral(): void {
    if (!this.busquedaGeneral) {
      return;
    }

    this.busquedaGeneral = '';

    this.registrarTrazabilidad(
      'BOTON',
      'Limpiar buscador general',
      'Click',
      null
    );

    this.aplicarFiltros();
  }

  exportarRegistros(): void {
    if (!this.filteredCotizaciones.length) {
      this.snackBar.open('No hay registros para exportar.', 'Cerrar', { duration: 3000 });
      return;
    }

    this.registrarTrazabilidad(
      'BOTON',
      'Exportar registros',
      `Cantidad registros: ${this.filteredCotizaciones.length}`,
      null
    );

    const idJefe = String(this.IdAsesor ?? '').trim();
    if (!idJefe) {
      this.snackBar.open('Aún no se ha cargado el asesor logueado.', 'Cerrar', { duration: 3000 });
      return;
    }

    const ids = this.filteredCotizaciones.map(c => Number(c.numeroCotizacion)).filter(id => !isNaN(id));

    this.seguimientoJefeService.exportarSeguimiento(idJefe, ids).subscribe({
      next: (blob) => {
        const timestamp = new Date().toISOString().replace(/[-T:.Z]/g, '').slice(0, 15);
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `seguimiento_cotizaciones_${timestamp}.xlsx`;
        a.click();
        URL.revokeObjectURL(url);
        this.snackBar.open('Exportación realizada con éxito.', 'Cerrar', { duration: 3000 });
      },
      error: (err) => {
        console.error('Error al exportar', err);
        this.snackBar.open('Ocurrió un error durante la exportación.', 'Cerrar', { duration: 4000 });
      }
    });
  }

  /**
   * Normaliza el tipo de solicitud del servidor a los valores del formulario
   */
  private normalizarTipoSolicitud(valor: string | null | undefined): string {
    if (!valor) return '';
    const normalizado = valor.trim().toLowerCase();
    
    switch (normalizado) {
      case 'colectivo nuevo':
      case 'nuevo colectivo':
        return 'colectivo_nuevo';
      case 'inclusión':
      case 'inclusion':
        return 'inclusion';
      case 'venta nueva':
      case 'nueva venta':
        return 'venta_nueva';
      default:
        return valor;
    }
  }

  private obtenerCotizacionesFiltradas(): Cotizacion[] {
    const filtros = this.filtrosForm.value;
    const busqueda = this.normalizarTexto(this.busquedaGeneral);

    return this.todasCotizaciones.filter((cotizacion) => {
      if (filtros.fechaCotizacionDesde && cotizacion.fechaCreacion < filtros.fechaCotizacionDesde) {
        return false;
      }

      if (filtros.fechaCotizacionHasta) {
        const finDiaHasta = new Date(filtros.fechaCotizacionHasta);
        finDiaHasta.setHours(23, 59, 59, 999);
        if (cotizacion.fechaCreacion > finDiaHasta) {
          return false;
        }
      }

      if (filtros.estadoCotizacion && cotizacion.estado !== filtros.estadoCotizacion) {
        return false;
      }

      if (filtros.tipoSolicitud && filtros.tipoSolicitud.length) {
        const tieneType = filtros.tipoSolicitud.some((tipo: string) =>
          this.normalizarTipoSolicitud(cotizacion.tipoSolicitud) === tipo
        );

        if (!tieneType) {
          return false;
        }
      }

      if (filtros.fechaCierreDesde) {
        if (!cotizacion.fechaCierre || cotizacion.fechaCierre < filtros.fechaCierreDesde) {
          return false;
        }
      }

      if (filtros.fechaCierreHasta) {
        const finDiaCierreHasta = new Date(filtros.fechaCierreHasta);
        finDiaCierreHasta.setHours(23, 59, 59, 999);
        if (!cotizacion.fechaCierre || cotizacion.fechaCierre > finDiaCierreHasta) {
          return false;
        }
      }

      const asesorSeleccionado = String(
        filtros.asesorComercial ?? ''
      ).trim();

      if (
        asesorSeleccionado &&
        String(cotizacion.asesorCodigo ?? '').trim() !== asesorSeleccionado
      ) {
        return false;
      }

      if (busqueda) {
        const fechaCreacionTexto = this.formatearFechaBusqueda(cotizacion.fechaCreacion);

        const fechaCierreTexto = cotizacion.fechaCierre
        ? this.formatearFechaBusqueda(cotizacion.fechaCierre)
        : 'NO APLICA';

        const asesorCodigoNombre = `${cotizacion.asesorCodigo ?? ''} - ${cotizacion.asesorNombre ?? ''}`;

        const contenido = this.normalizarTexto([
          cotizacion.asesorCodigo,
          cotizacion.asesorNombre,
          asesorCodigoNombre,
          cotizacion.numeroCotizacion,
          cotizacion.tipoSolicitud,
          this.obtenerLineasNegocioResumen(cotizacion.lineasNegocio),
          cotizacion.estado,
          fechaCreacionTexto,
          fechaCierreTexto,
          this.seguimientoLabels[cotizacion.seguimiento] ?? '',
        ].join(' '));

        if (!contenido.includes(busqueda)) {
          return false;
        }
      }

      return true;
    });
  }

  filtrarAsesores(termino: string): void {
    this.asesorBusqueda = termino ?? '';

    const busqueda = this.normalizarTexto(this.asesorBusqueda);

    if (!busqueda) {
      this.filteredAsesores = [...this.asesores];
      return;
    }

    this.filteredAsesores = this.asesores.filter((asesor) => {
      const codigo = this.normalizarTexto(asesor.codigo);
      const nombre = this.normalizarTexto(asesor.nombre);
      const codigoNombre = this.normalizarTexto(
        `${asesor.codigo} - ${asesor.nombre}`
      );

      return (
        codigo.includes(busqueda) ||
        nombre.includes(busqueda) ||
        codigoNombre.includes(busqueda)
      );
    });
  }

  private obtenerParametrosColectivoParaJasper(
    idCotizacion: number | string
  ): {
    porcentajeSubsidio: string;
    mostrarTodosEscenarios: boolean;
    aplicaAnexos: boolean;
    nombreJefe: string;
    cargoJefe: string;
  } {
    const parametrosStorage = localStorage.getItem(
      this.KEY_PARAMETROS_JASPER_COLECTIVO_STORAGE
    );

    const valoresPorDefecto = {
      porcentajeSubsidio: '0',
      mostrarTodosEscenarios: false,
      aplicaAnexos: false,
      nombreJefe: this.nombreAsesor?.trim() || '',
      cargoJefe: ''
    };

    if (!parametrosStorage) {
      return valoresPorDefecto;
    }

    try {
      const data = JSON.parse(parametrosStorage);

      if (!data || typeof data !== 'object') {
        return valoresPorDefecto;
      }

      const parametrosCotizacion = data[String(idCotizacion)];

      if (
        !parametrosCotizacion ||
        typeof parametrosCotizacion !== 'object'
      ) {
        return valoresPorDefecto;
      }

      return {
        porcentajeSubsidio:
          String(parametrosCotizacion.pPorcentajeSubsidio ?? '0'),

        mostrarTodosEscenarios:
          parametrosCotizacion.pMostrarTodosEscenarios === true ||
          parametrosCotizacion.pMostrarTodosEscenarios === 'true' ||
          parametrosCotizacion.pMostrarTodosEscenarios === '1',

        aplicaAnexos:
          parametrosCotizacion.pAplicaAnexos === true ||
          parametrosCotizacion.pAplicaAnexos === 'true' ||
          parametrosCotizacion.pAplicaAnexos === '1',

        nombreJefe:
          String(
            parametrosCotizacion.pNombreJefe ??
            this.nombreAsesor ??
            ''
          ).trim(),

        cargoJefe:
          String(
            parametrosCotizacion.pCargoJefe ??
            ''
          ).trim()
      };

    } catch (error) {
      console.error(
        'Error leyendo parámetros Jasper colectivo:',
        error
      );

      return valoresPorDefecto;
    }
  }

  private obtenerPComparativoParaJasper(): string {
    const compararStorage = localStorage.getItem('rq006_comparar_programas_por_linea');

    if (!compararStorage) {
      return '0';
    }

    try {
      const data = JSON.parse(compararStorage);

      if (!data || typeof data !== 'object') {
        return '0';
      }

      const tieneDosProgramasSeleccionados = Object.values(data).some((programas: any) => {
        return Array.isArray(programas) && programas.length >= 2;
      });

      return tieneDosProgramasSeleccionados ? '1' : '0';
    } catch (error) {
      console.error('Error leyendo selección de comparar:', error);
      return '0';
    }
  }

  private obtenerPCuotaInscripcionParaJasper(
    idCotizacion: number | string
  ): string {
    const parametrosStorage = localStorage.getItem(
      this.KEY_PARAMETROS_JASPER_STORAGE
    );

    if (!parametrosStorage) {
      return '0';
    }

    try {
      const data = JSON.parse(parametrosStorage);

      if (!data || typeof data !== 'object') {
        return '0';
      }

      const parametrosCotizacion =
        data[String(idCotizacion)];

      if (
        !parametrosCotizacion ||
        typeof parametrosCotizacion !== 'object'
      ) {
        return '0';
      }

      return parametrosCotizacion
        .pCuotaInscripcion === '1'
          ? '1'
          : '0';
    } catch (error) {
      console.error(
        'Error leyendo cuota de inscripción:',
        error
      );

      return '0';
    }
  }

  private obtenerPPagoProporcionalParaJasper(
    idCotizacion: number | string
  ): string {
    const parametrosStorage = localStorage.getItem(
      this.KEY_PARAMETROS_JASPER_STORAGE
    );

    if (!parametrosStorage) {
      return '0';
    }

    try {
      const data = JSON.parse(parametrosStorage);

      if (!data || typeof data !== 'object') {
        return '0';
      }

      const parametrosCotizacion =
        data[String(idCotizacion)];

      if (
        !parametrosCotizacion ||
        typeof parametrosCotizacion !== 'object'
      ) {
        return '0';
      }

      return parametrosCotizacion
        .pPagoProporcionalAnticipado === '1'
          ? '1'
          : '0';
    } catch (error) {
      console.error(
        'Error leyendo pago proporcional:',
        error
      );

      return '0';
    }
  }

  private obtenerPPrecioBaseAnexosParaJasper(
    idCotizacion: number | string
  ): string {
    const parametrosStorage = localStorage.getItem(
      this.KEY_PARAMETROS_JASPER_STORAGE
    );

    if (!parametrosStorage) {
      return '0';
    }

    try {
      const data = JSON.parse(parametrosStorage);

      if (!data || typeof data !== 'object') {
        return '0';
      }

      const parametrosCotizacion =
        data[String(idCotizacion)];

      if (
        !parametrosCotizacion ||
        typeof parametrosCotizacion !== 'object'
      ) {
        return '0';
      }

      return parametrosCotizacion
        .pPrecioBaseAnexos === '1'
          ? '1'
          : '0';
    } catch (error) {
      console.error(
        'Error leyendo precio base de anexos:',
        error
      );

      return '0';
    }
  }

  private crearPdfIndividualUrl(idCotizacion: number, asesor: AsesorData): string {
    const nombreArchivo = `Cotización_${idCotizacion}.pdf`;
    const params = new HttpParams()
      .set('idCotizacion', idCotizacion.toString())
      .set('nombreAsesor', asesor.NombreCompleto.trim())
      .set('telefonoAsesor', asesor.telefono.trim())
      .set('correoAsesor', asesor.email.trim())
      .set('comparativo', this.obtenerPComparativoParaJasper())
      .set('cuotaInscripcion', this.obtenerPCuotaInscripcionParaJasper(idCotizacion))
      .set('pagoProporcionalAnticipado', this.obtenerPPagoProporcionalParaJasper(idCotizacion))
      .set('precioBaseAnexos', this.obtenerPPrecioBaseAnexosParaJasper(idCotizacion))
      .set('ciudadAsesor', this.capitalizeFirstLetter(asesor.ciudad?.trim() ?? ''));

    return `${environment.HOST}${URL_MAP.API.PDF_COTIZACION_INDIVIDUAL}/${nombreArchivo}?${params.toString()}`;
  }

  private crearPdfColectivoUrl(
    idCotizacion: number,
    asesor: AsesorData
  ): string {
    const nombreArchivo = `Cotización_${idCotizacion}.pdf`;

    const parametrosColectivo =
      this.obtenerParametrosColectivoParaJasper(idCotizacion);

    const params = new HttpParams()
      .set('idCotizacion', idCotizacion.toString())
      .set('nombreAsesor', asesor.NombreCompleto.trim())
      .set('telefonoAsesor', asesor.telefono.trim())
      .set('correoAsesor', asesor.email.trim())
      .set(
        'ciudadAsesor',
        this.capitalizeFirstLetter(asesor.ciudad?.trim() ?? '')
      )
      .set(
        'porcentajeSubsidio',
        parametrosColectivo.porcentajeSubsidio
      )
      .set(
        'mostrarTodosEscenarios',
        String(parametrosColectivo.mostrarTodosEscenarios)
      )
      .set(
        'aplicaAnexos',
        String(parametrosColectivo.aplicaAnexos)
      )
      .set(
        'nombreJefe',
        parametrosColectivo.nombreJefe
      )
      .set(
        'cargoJefe',
        parametrosColectivo.cargoJefe
      );

    return `${environment.HOST}${URL_MAP.API.PDF_COTIZACION_COLECTIVO}/${nombreArchivo}?${params.toString()}`;
  }

  private cerrarVentanaPdf(ventanaPdf: Window | null): void {
    if (ventanaPdf && !ventanaPdf.closed) {
      ventanaPdf.close();
    }
  }

  verPdfCotizacion(cotizacion: Cotizacion): void {
    const idCotizacion = Number(cotizacion.numeroCotizacion);
    const idAsesorCreador = String(cotizacion.asesorCodigo ?? '').trim();

    if (!Number.isFinite(idCotizacion) || idCotizacion <= 0) {
      this.snackBar.open('No se encontró el número de cotización.', 'Cerrar', { duration: 3000 });
      return;
    }

    if (!idAsesorCreador) {
      this.snackBar.open('No se encontró el asesor que creó la cotización.', 'Cerrar', { duration: 3000 });
      return;
    }

    const ventanaPdf = window.open('about:blank', '_blank');
    if (!ventanaPdf) {
      this.snackBar.open('El navegador bloqueó la ventana del PDF.', 'Cerrar', { duration: 3000 });
      return;
    }
    ventanaPdf.opener = null;

    const request = {
      nombreClave: 'getSpCotConsultarAsesorPorID',
      jsonParametros: JSON.stringify({
        prm_id_asesor: idAsesorCreador
      })
    };

    this.spinner.show();
    this.consultarAsesorByIDService.consultarAsesorByID(request)
      .pipe(takeUntil(this._onDestroy))
      .subscribe({
      next: (response) => {
        const asesorCreador = response?.status && Array.isArray(response.data)
          ? response.data[0]
          : null;

        if (!asesorCreador) {
          this.spinner.hide();
          this.cerrarVentanaPdf(ventanaPdf);
          this.snackBar.open('No se encontraron los datos del asesor que creó la cotización.', 'Cerrar', { duration: 3000 });
          return;
        }

        const esColectivo = Number(cotizacion.idTipoSolicitud) === 3;
        if (!esColectivo && (!asesorCreador.NombreCompleto?.trim() || !asesorCreador.telefono?.trim() || !asesorCreador.email?.trim())) {
          this.spinner.hide();
          this.cerrarVentanaPdf(ventanaPdf);
          this.snackBar.open('Los datos del asesor creador están incompletos para generar el PDF.', 'Cerrar', { duration: 3000 });
          return;
        }

        const pdfUrl = esColectivo
          ? this.crearPdfColectivoUrl(idCotizacion, asesorCreador)
          : this.crearPdfIndividualUrl(idCotizacion, asesorCreador);

        try {
          ventanaPdf.location.href = pdfUrl;
        } catch (error) {
          this.spinner.hide();
          this.cerrarVentanaPdf(ventanaPdf);
          console.error('Error abriendo el PDF de la cotización:', error);
          this.snackBar.open('No fue posible abrir el PDF de la cotización.', 'Cerrar', { duration: 3000 });
          return;
        }

        this.spinner.hide();

        this.registrarTrazabilidad(
          'BOTON',
          'Ver PDF',
          'Click',
          idCotizacion
        );
      },
      error: (error) => {
        this.spinner.hide();
        this.cerrarVentanaPdf(ventanaPdf);
        console.error('Error consultando el asesor creador de la cotización:', error);
        this.snackBar.open('No fue posible obtener los datos del asesor para generar el PDF.', 'Cerrar', { duration: 3000 });
      }
    });
  }

  verSeguimientoCotizacion(cotizacion: Cotizacion): void {
    this.registrarTrazabilidad(
      'BOTON',
      'Ver seguimiento',
      'Click',
      cotizacion.numeroCotizacion
    );

    const dialogRef = this.dialog.open(DialogSeguimientoCotizacionComponent, {
      width: '900px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      data: {
        idCotizacion: Number(cotizacion.numeroCotizacion),
        numeroCotizacion: cotizacion.numeroCotizacion,
        nombreCliente: cotizacion.nombreContratante ?? ''
      },
      disableClose: false,
      panelClass: 'modal-seguimiento-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Seguimiento guardado:', result);
        this.snackBar.open('Seguimiento guardado correctamente.', 'Cerrar', { duration: 3000 });
      }
    });
  }

  private actualizarDashboard(): void {
    const anoActual = new Date().getFullYear();
    const cotizacionesAno = this.filteredCotizaciones.filter((cotizacion) => cotizacion.fechaCreacion.getFullYear() === anoActual);
    this.totalCotizaciones = cotizacionesAno.length;

    this.porcentajeCumplimientoMeta = this.metaCotizaciones
      ? Math.min(100, Math.round((this.totalCotizaciones / this.metaCotizaciones) * 100))
      : 0;

    const cotizacionesConCierre = this.filteredCotizaciones.filter((cotizacion) => cotizacion.fechaCierre && (cotizacion.estado === 'aceptada' || cotizacion.estado === 'cerrada'));
    if (cotizacionesConCierre.length) {
      const totalDias = cotizacionesConCierre.reduce((acum, cotizacion) => {
        const diff = (cotizacion.fechaCierre!.getTime() - cotizacion.fechaCreacion.getTime()) / (1000 * 60 * 60 * 24);
        return acum + diff;
      }, 0);
      this.tiempoPromedioCierre = Math.round(totalDias / cotizacionesConCierre.length);
    } else {
      this.tiempoPromedioCierre = 0;
    }

    this.lineChartData = this.calcularEvolucionCotizaciones(this.filteredCotizaciones);
    this.generarLineChartGeometry();
    this.pieChartData = this.calcularDistribucionEstados(this.filteredCotizaciones);
    this.actualizarPieChartBackground();
    this.seguimientoChartData = this.calcularSeguimientoConAlturas(this.filteredCotizaciones);
    this.lineasNegocioChartData = this.calcularLineasNegocioConAlturas(this.filteredCotizaciones);
    this.tieneSeguimientoDatos = this.seguimientoChartData.some((item) => item.value > 0);
    this.tieneLineasDatos = this.lineasNegocioChartData.some((item) => item.value > 0);
    const segGeom = this.generarBarChartGeometry(this.seguimientoChartData);
    this.seguimientoSvgBars = segGeom.bars;
    this.seguimientoSvgGridLines = segGeom.gridLines;
    const linGeom = this.generarBarChartGeometry(this.lineasNegocioChartData);
    this.lineasNegocioSvgBars = linGeom.bars;
    this.lineasNegocioSvgGridLines = linGeom.gridLines;
  }

  private calcularEvolucionCotizaciones(cotizaciones: Cotizacion[]): ChartPoint[] {
    const agrupado = new Map<number, { label: string; value: number }>();
    cotizaciones.forEach((cotizacion) => {
      const clave = cotizacion.fechaCreacion.getFullYear() * 100 + cotizacion.fechaCreacion.getMonth();
      const label = cotizacion.fechaCreacion.toLocaleDateString('es-CO', { month: 'short', year: 'numeric' });
      const existente = agrupado.get(clave);
      if (existente) {
        existente.value += 1;
      } else {
        agrupado.set(clave, { label, value: 1 });
      }
    });
    return Array.from(agrupado.entries())
      .sort((a, b) => a[0] - b[0])
      .map(([, datos]) => datos);
  }

  private generarLineChartGeometry(): void {
    const leftPad  = 70;
    const rightPad = 20;
    const topPad   = 15;
    const bottomPad = 35;
    const width  = 620;
    const height = 260;
    const chartH = height - topPad - bottomPad; // 210
    const chartBottom = height - bottomPad;     // 225

    if (!this.lineChartData.length) {
      this.lineChartPolylinePoints = '';
      this.lineChartNodes = [];
      this.lineChartGridLines = [];
      return;
    }

    const maxValor  = Math.max(...this.lineChartData.map((p) => p.value), 1);
    // Escala "nice": múltiplo de 5 si maxValor >= 5, sino usar el valor exacto
    const maxEscala = maxValor >= 5 ? Math.ceil(maxValor / 5) * 5 : maxValor;

    // Generar líneas del grid: hasta 4 niveles proporcionales
    this.lineChartGridLines = [];
    const pasos = maxEscala <= 4 ? maxEscala : 5;
    for (let i = 1; i <= pasos; i++) {
      const v = Math.round((maxEscala / pasos) * i);
      if (v === 0) continue;
      const y = chartBottom - (v / maxEscala) * chartH;
      this.lineChartGridLines.push({ y, value: v });
    }

    const chartW = width - leftPad - rightPad; // 530
    // Un solo punto: centrarlo; varios puntos: distribuir uniformemente
    const pasoX  = this.lineChartData.length > 1
      ? chartW / (this.lineChartData.length - 1)
      : 0;

    const puntos = this.lineChartData.map((punto, index) => {
      const x = this.lineChartData.length === 1
        ? leftPad + chartW / 2
        : leftPad + index * pasoX;
      const y = chartBottom - (punto.value / maxEscala) * chartH;
      return { x, y, label: punto.label, value: punto.value };
    });

    this.lineChartPolylinePoints = puntos.map((p) => `${p.x},${p.y}`).join(' ');
    this.lineChartNodes = puntos.map((p, i) => {
      const showLabel = i % Math.max(1, Math.ceil(puntos.length / 6)) === 0 || i === puntos.length - 1;
      const xLabelY = chartBottom + 16;
      return {
        cx: p.x, cy: p.y, label: p.label, value: p.value,
        showLabel,
        labelX: p.x,
        labelY: xLabelY,
        labelTransform: `rotate(-35 ${p.x} ${xLabelY})`
      };
    });
  }

  private calcularDistribucionEstados(cotizaciones: Cotizacion[]): Array<{ label: string; value: number; color: string }> {
    const colores: Record<string, string> = {
      enviada: '#4c8de3',
      aceptada: '#4caf50',
      cerrada: '#ff9800',
      incompleta: '#9c27b0'
    };
    const conteo = new Map<string, number>();
    cotizaciones.forEach((cotizacion) => {
      const estado = cotizacion.estado?.toLowerCase() || '';
      conteo.set(estado, (conteo.get(estado) ?? 0) + 1);
    });
    return Array.from(conteo.entries()).map(([estado, value]) => ({
      label: estado,
      value,
      color: colores[estado] ?? '#cccccc'
    }));
  }

  private actualizarPieChartBackground(): void {
    const total = this.pieChartData.reduce((acc, item) => acc + item.value, 0);
    if (!total) {
      this.pieChartBackground = 'conic-gradient(#e0e0e0 0 100%)';
      this.pieSvgSlices = [];
      return;
    }
    let acumulado = 0;
    const segmentos = this.pieChartData.map((segmento) => {
      const inicio = acumulado;
      const porcentaje = (segmento.value / total) * 100;
      acumulado += porcentaje;
      return `${segmento.color} ${inicio}% ${acumulado}%`;
    });
    this.pieChartBackground = `conic-gradient(${segmentos.join(',')})`;  

    // Generar slices SVG
    const cx = 110, cy = 110, r = 80, rLabel = 102;
    const toRad = (deg: number) => (deg - 90) * Math.PI / 180;
    const polar = (angle: number, radius: number) => ({
      x: cx + radius * Math.cos(toRad(angle)),
      y: cy + radius * Math.sin(toRad(angle))
    });
    let startAngle = 0;
    this.pieSvgSlices = this.pieChartData.filter(seg => seg.value > 0).map((seg) => {
      const pct = (seg.value / total) * 100;
      const sweep = (pct / 100) * 360;
      const endAngle = startAngle + sweep;
      // Caso especial: slice de 360° (único segmento 100%) — el arco sería degenerado
      let path: string;
      if (sweep >= 359.99) {
        path = `M ${cx - r} ${cy} A ${r} ${r} 0 1 1 ${cx + r} ${cy} A ${r} ${r} 0 1 1 ${cx - r} ${cy} Z`;
      } else {
        const s = polar(startAngle, r);
        const e = polar(endAngle, r);
        const largeArc = sweep > 180 ? 1 : 0;
        path = `M ${cx} ${cy} L ${s.x.toFixed(2)} ${s.y.toFixed(2)} A ${r} ${r} 0 ${largeArc} 1 ${e.x.toFixed(2)} ${e.y.toFixed(2)} Z`;
      }
      const mid = polar(startAngle + sweep / 2, rLabel);
      startAngle = endAngle;
      return { path, color: seg.color, labelX: mid.x, labelY: mid.y, pct: pct.toFixed(0) + '%' };
    });
  }

  private generarBarChartGeometry(items: BarChartItem[]): { bars: SvgBar[]; gridLines: Array<{ y: number; value: number }> } {
    const leftPad = 50, rightPad = 10, topPad = 20, bottomPad = 40;
    const totalW = 380, totalH = 220;
    const chartW = totalW - leftPad - rightPad;
    const chartH = totalH - topPad - bottomPad;
    const chartBottom = totalH - bottomPad;

    if (!items.length) return { bars: [], gridLines: [] };

    const maxValor = Math.max(...items.map((i) => i.value), 1);

    // Calcular paso "nice": apuntar a ~4 líneas
    const rawStep = maxValor / 4;
    const magnitude = Math.pow(10, Math.floor(Math.log10(rawStep)));
    const niceSteps = [1, 2, 5, 10, 15, 20, 25, 50];
    let step = niceSteps.find(s => s * magnitude >= rawStep) ?? 10;
    step = step * magnitude;
    const maxEscala = Math.ceil(maxValor / step) * step;

    // Grid lines incluyendo 0
    const gridLines: Array<{ y: number; value: number }> = [];
    gridLines.push({ y: chartBottom, value: 0 }); // línea 0
    for (let v = step; v <= maxEscala; v += step) {
      const y = chartBottom - (v / maxEscala) * chartH;
      gridLines.push({ y, value: v });
    }

    const numBars = items.length;
    const slotW = chartW / numBars;
    const barW = slotW * 0.65;

    const bars: SvgBar[] = items.map((item, i) => {
      const slotX = leftPad + i * slotW;
      const rx = slotX + (slotW - barW) / 2;
      const barH = item.value === 0 ? 0 : (item.value / maxEscala) * chartH;
      const ry = chartBottom - barH;
      return {
        rx, ry, rw: barW, rh: barH,
        label: item.label, value: item.value,
        labelX: slotX + slotW / 2,
        labelY: chartBottom + 16,
        valueX: slotX + slotW / 2,
        valueY: ry - 5
      };
    });

    return { bars, gridLines };
  }

  private calcularSeguimientoConAlturas(cotizaciones: Cotizacion[]): BarChartItem[] {
    const categorias: Array<'vencidas' | 'por_gestionar' | 'cumplimiento'> = ['vencidas', 'por_gestionar', 'cumplimiento'];
    const conteo = new Map<string, number>(categorias.map((categoria) => [categoria, 0]));
    cotizaciones.forEach((cotizacion) => {
      if (conteo.has(cotizacion.seguimiento)) {
        conteo.set(cotizacion.seguimiento, (conteo.get(cotizacion.seguimiento) ?? 0) + 1);
      }
    });
    const datos = categorias.map((clave) => ({ label: this.seguimientoLabels[clave], value: conteo.get(clave) ?? 0 }));
    const maxValor = Math.max(...datos.map((item) => item.value), 1);
    return datos.map((item) => ({
      ...item,
      altura: item.value === 0 ? '0%' : `${(item.value / maxValor) * 100}%`
    }));
  }

  private calcularLineasNegocioConAlturas(cotizaciones: Cotizacion[]): BarChartItem[] {
    const labels = [...new Set(cotizaciones.flatMap(c => c.lineasNegocio))];

    if (!labels.length) return [];

    const conteo = new Map<string, number>(labels.map((label) => [label, 0]));
    cotizaciones.forEach((cotizacion) => {
      const lineasUnicas = new Set(cotizacion.lineasNegocio);
      lineasUnicas.forEach((linea) => {
        if (conteo.has(linea)) {
          conteo.set(linea, (conteo.get(linea) ?? 0) + 1);
        }
      });
    });

    const datos = labels.sort().map((label) => ({ label, value: conteo.get(label) ?? 0 }));
    const maxValor = Math.max(...datos.map((item) => item.value), 1);
    return datos.map((item) => ({
      ...item,
      altura: item.value === 0 ? '0%' : `${(item.value / maxValor) * 100}%`
    }));
  }

  obtenerLineasNegocioResumen(lineas: string[]): string {
    const lineasNormalizadas = [...new Set(lineas.map(l => this.normalizarLineaNegocio(l)))];
    const orden = ['MI', 'SAO', 'CEM'];
    const ordenadas = orden.filter((linea) => lineasNormalizadas.includes(linea));
    return ordenadas.join(' - ');
  }

  textoCumplimientoSeguimiento(row: Cotizacion): string {
    const estado = (row.estado ?? '').toUpperCase();
    if (estado === 'ACEPTADA' || estado === 'CERRADA') {
      return 'NO APLICA';
    }
    if (!row.fechaSeguimiento) {
      return 'SIN SEGUIMIENTO';
    }
    return this.formatearFechaBusqueda(row.fechaSeguimiento);
  }

  clasePuntoSeguimiento(row: Cotizacion): string {
    const estado = (row.estado ?? '').toUpperCase();
    if (estado === 'ACEPTADA' || estado === 'CERRADA') {
      return '';
    }
    if (!row.fechaSeguimiento) {
      return 'seguimiento-gris';
    }
    return this.obtenerColorSeguimiento(row.seguimiento);
  }

  obtenerColorSeguimiento(seguimiento: 'vencidas' | 'por_gestionar' | 'cumplimiento'): string {
    const colores: Record<string, string> = {
      'vencidas': 'seguimiento-rojo',
      'por_gestionar': 'seguimiento-amarillo',
      'cumplimiento': 'seguimiento-verde'
    };
    return colores[seguimiento] || '';
  }
}
